import React from 'react';
import styled from 'styled-components';

import Base from '../StyledSVGBase';

const Import = styled(Base)`
  fill: ${(props) => props.color || '#a0a0a0'};
  &:hover {
    fill: ${(props) => props.hoverColor || '#66bb6a'};
    cursor: pointer;
  }
`;
Import.displayName = 'ImportIcon-Import';

export default function ImportIcon(props) {
  return (
    <svg width={props.size || 24} height={props.size || 24} viewBox="0 0 24 24">
      <Import {...props}>
        <path fill="none" d="M0,0H24V24H0Z" />
        <path d="M4,19H20V12h2v8a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V12H4ZM14,9h5l-7,7L5,9h5V3h4Z" />
      </Import>
    </svg>
  );
}
